/* import __COLOCATED_TEMPLATE__ from './noise-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';
import { alias } from '@ember/object/computed';
import PrettyNum from '../utils/pretty-num-wrapper';

export default class NoisePanel extends Component {
    tagName = '';

    @service intl;
    @service('data') model;
    @service tabService;
    @service errorHandling;
    @service hashDataService;
    @service plotDataService;
    @service componentManager;

    @alias('model.noiseCalculations') noiseCalculations;

    menuId = 'noise-tabs';

    updateAppData = () => {};

    @computed('model.frequency') get prettyFrequency() {
        return `${PrettyNum.eng3(this.model.frequency)}${this.intl.t('units.hz')}`;
    }

    @computed('plotDataService.noiseArrays.systemThdAtF') get prettySystemThdAtF() {
        if (!this.plotDataService.noiseArrays) return null;
        return `${PrettyNum.eng3(this.plotDataService.noiseArrays.systemThdAtF, { separatedUnit: true })}${this.intl.t(
            'units.db',
        )}`;
    }

    @computed('plotDataService.noiseArrays.enobAtF') get prettyEnobAtF() {
        if (!this.plotDataService.noiseArrays) return null;
        return `${PrettyNum.eng3(this.plotDataService.noiseArrays.enobAtF, { separatedUnit: true })}${this.intl.t(
            'units.bits',
        )}`;
    }

    @computed('plotDataService.noiseArrays.sinadAtF') get prettySinadAtF() {
        if (!this.plotDataService.noiseArrays) return null;
        return `${PrettyNum.eng3(this.plotDataService.noiseArrays.sinadAtF, { separatedUnit: true })}${this.intl.t(
            'units.db',
        )}`;
    }

    @computed('noiseCalculations.total.totalSnr') get prettyTotalSnr() {
        if (!(this.noiseCalculations && this.noiseCalculations.total)) return null;
        return `${PrettyNum.eng4(this.noiseCalculations.total.totalSnr, {
            scale: 1,
            separatedUnit: true,
        })}${this.intl.t('units.db')}`;
    }

    @computed('noiseCalculations.total.totalVrms') get prettyTotalVrms() {
        if (!(this.noiseCalculations && this.noiseCalculations.total)) return null;
        return `${PrettyNum.eng3(this.noiseCalculations.total.totalVrms, { separatedUnit: true })}${this.intl.t(
            'units.vrms',
        )}`;
    }

    @computed('noiseCalculations.driver.totalVrms') get prettyDriverTotalVrms() {
        if (!(this.noiseCalculations && this.noiseCalculations.driver)) return null;
        return `${PrettyNum.eng3(this.noiseCalculations.driver.totalVrms, { separatedUnit: true })}${this.intl.t(
            'units.vrms',
        )}`;
    }

    @action onOptionalSourceSettingsChange() {
        this.set('model.showOptionalSourceSettings', !this.model.showOptionalSourceSettings);
        this.hashDataService.setOptionalSourceSettingsProperties();

        this.hashDataService.setUrlParameter('model.wbNoise');
        this.hashDataService.setUrlParameter('model.thd');

        this.hashDataService.setUrlParameter('model.showOptionalSourceSettings');

        if (this.updateAppData) this.updateAppData();
    }

    @action onWbNoiseChange() {
        this.hashDataService.setUrlParameter('model.wbNoise');

        if (this.updateAppData) this.updateAppData();
    }

    @action onThdChange() {
        this.hashDataService.setUrlParameter('model.thd');

        if (this.updateAppData) this.updateAppData();
    }
}
